module.exports = "/fonts/Cabin-Bold.ttf";